import { useEffect, useState } from "react";
import { parseFromSessionStorage } from "./helper";

const VIPER_PROFILE_KEY = "viper:profile";

/**
 * Accesses the viper:profile key in session storage and provides a function for updating it.
 *
 * @return {Array} An array of the profile object and a function to set the profile.
 */
const useViperProfile = () => {
  const [profile, setProfile] = useState(
    parseFromSessionStorage(VIPER_PROFILE_KEY)
  );

  useEffect(() => {
    setProfile(parseFromSessionStorage(VIPER_PROFILE_KEY));
  }, [setProfile]);

  return profile;
};

export default useViperProfile;
